import { render } from "./insInfo.vue?vue&type=template&id=9ee9c47e&scoped=true&ts=true"
import script from "./insInfo.vue?vue&type=script&lang=ts"
export * from "./insInfo.vue?vue&type=script&lang=ts"

import "./insInfo.vue?vue&type=style&index=0&id=9ee9c47e&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ee9c47e"]])

export default __exports__